// extracted by mini-css-extract-plugin
export default {"errorHint":"useErrorHandler_errorHint__yiKfZ"};